import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";
import ClientContent from "./ClientContent";
import { useLocation, useNavigate } from "react-router-dom";
import ClientContentMobile from "./ClientContentMobile";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useMediaQuery } from "react-responsive";

export default function Client() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });

  const location = useLocation();
  const clientData = location.state;
  const clientId = clientData && clientData.docId;
  const isPhilippinesClient =
    clientData?.rehabId === "miracles_asia_philippines" ||
    clientData?.rehabCountry === "Philippines";

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <ClientContentMobile clientId={clientId} />
        </>
      ) : (
        <>
          <Navbar linkActive={isPhilippinesClient ? 22 : 1} />
          <ClientContent clientId={clientId} />
        </>
      )}
    </div>
  );
}
